import React, { useContext } from "react";
import { Page, hasActiveFilters } from "@sscs/ui";
import { formatCount } from "@sscs/utils";
import { filterUpdated, initFilter, paginationUpdated, selectFilter, selectPagination, selectSort, sortUpdated, } from "../../store/behaviorSlice";
import { ReportContext } from "../context";
import { useReportDispatch, useReportSelector } from "../hooks";
import { useGetBehaviorQuery } from "../services/behavior.api";
import { useGetReportSummaryQuery } from "../services/shared.api";
import { getQueryStatus } from "../utils";
import BehaviourFilter from "./behaviourFilter/BehaviourFilter";
import BehaviourTable from "./BehaviourTable";
const Behaviour = () => {
    var _a;
    const dispatch = useReportDispatch();
    const { reportId, diffId } = useContext(ReportContext);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const { data: fetchedData, isLoading, isFetching, isError, error, } = useGetBehaviorQuery({
        filter,
        sort,
        pagination,
        ui_id: reportId,
    });
    const data = fetchedData
        ? fetchedData
        : {
            behaviors: [],
            match_count: 0,
        };
    return (React.createElement(Page.Root, null,
        React.createElement(Page.Header, { title: "Behavior", details: [
                formatCount((_a = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.counters.behavior) !== null && _a !== void 0 ? _a : 0, "Behavior"),
            ] }),
        React.createElement(Page.Filters, { found: {
                id: "behavior-clear-all-filters",
                count: data.match_count,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => dispatch(filterUpdated(initFilter)),
            } },
            React.createElement(BehaviourFilter, { filter: filter, onFilterChange: (filter) => dispatch(filterUpdated(filter)) })),
        React.createElement(Page.Body, null,
            React.createElement(BehaviourTable, { indicators: data.behaviors, sort: sort, searchRegex: filter.description ? filter.description : "", filters: {
                    active: hasActiveFilters(initFilter, filter),
                    onReset: () => dispatch(filterUpdated(initFilter)),
                }, onSortChange: (sort) => dispatch(sortUpdated(sort)), status: getQueryStatus({
                    isLoading,
                    isFetching,
                    isError,
                    error,
                    data: fetchedData,
                }), itemCount: data.match_count, pagination: pagination, onPaginationChange: (pagination) => dispatch(paginationUpdated(pagination)) }))));
};
export default Behaviour;
//# sourceMappingURL=Behaviour.js.map